export default __webpack_public_path__ + "static/media/grainBuds_03.d2c63e55.png";